export const isLastIndex = (index: number, arr: Array<unknown>) =>
  index === arr.length - 1;
